import { useDebounceFn } from '@vueuse/core'

import filterStoresByAssortment from '@/lib/filterStoresByAssortment'
import type { Store } from '@/types'

interface FilterMapMarkersByAssortmentsProps {
  markers: google.maps.Marker[] | undefined
  map: google.maps.Map | undefined
  response: { features: Store[] } | undefined
  event: CustomEventInit
}

const FilterMapMarkersByAssortments = useDebounceFn(
  ({
    markers,
    map,
    response,
    event,
  }: FilterMapMarkersByAssortmentsProps): undefined => {
    const filters = event.detail as string[]

    if (!markers) return

    for (const marker of markers) {
      const currentMapBounds = map?.getBounds() as google.maps.LatLngBounds
      const markerCoords = {
        lat: marker.getPosition()?.lat(),
        lng: marker.getPosition()?.lng(),
      } as google.maps.LatLngLiteral

      const isMarkerInBounds = currentMapBounds.contains(markerCoords)

      if (isMarkerInBounds) {
        const markerMatchesAssortment = filterStoresByAssortment({
          // @ts-ignore
          assortments: marker.assortment,
          filters,
          stores: response?.features,
        })

        if (!markerMatchesAssortment) {
          marker.setVisible(false)
        }

        if (markerMatchesAssortment) {
          marker.setVisible(true)
        }
      }
    }
  },
  500,
)

export default FilterMapMarkersByAssortments
